// import Rails from '@rails/ujs';
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = ["template", "links"]

  connect() {
  }

  add_association(event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.linksTarget.insertAdjacentHTML("beforebegin", content);
  }

  remove_association(event) {
    event.preventDefault();

    const wrapper = event.target.closest(".deep-nested-fields");
    console.log("wrapper:", wrapper);
    if (wrapper.dataset.newRecord == "true") {
      wrapper.remove();
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1;
      wrapper.style.display = "none";
    }
  }
}
